import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Direction, TabPanel, Tabs } from '../../../components/molecules/Tabs';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatisticDaily, StatisticMonthly, StatisticYearly } from '../PageStatistics.types';
import { PageStatisticsTable } from '../partials/PageStatisticsTable';
import { PageStatisticsTableOnlyTotal } from '../partials/PageStatisticsTableOnlyTotal';
import { MostPopularPagesTable, PageItem } from '../../../_lib/components/MostPopularPagesTable/MostPopularPagesTable';

type PageStatistics = {
  daily: StatisticDaily[];
  monthly: StatisticMonthly[];
  yearly: StatisticYearly[];
  pageFavorites?: PageItem[];
  pageVisits?: PageItem[];
  pageWatches?: PageItem[];
};

function PageStatisticsDefault({ daily, monthly, yearly, pageFavorites, pageVisits, pageWatches }: PageStatistics) {
  const { t } = useSonTranslation('PageStatistics');

  return (
    <Tabs initialActiveTab="page-statistics-tab-daily" direction={Direction.VERTICAL} label={t('tabs.label')}>
      <TabPanel buttonLabel={t('tabs.button.daily')} id="page-statistics-tab-daily">
        <PageStatisticsTable statistics={daily} type="daily" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.monthly')} id="page-statistics-tab-monthly">
        <PageStatisticsTable statistics={monthly} type="monthly" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.yearly')} id="page-statistics-tab-yearly">
        <PageStatisticsTableOnlyTotal statistics={yearly} type="yearly" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.mostVisited')} id="most-popular-pages-tab-visited">
        <MostPopularPagesTable
          caption={t('MostPopularPages:caption.visited')}
          items={pageVisits}
          countLabelPostFix={t('MostPopularPages:countLabelPostFix.visited')}
          emptyNotice={t('MostPopularPages:notice.noVisits')}
        />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.mostWatched')} id="most-popular-pages-tab-watched">
        <MostPopularPagesTable
          caption={t('MostPopularPages:caption.watched')}
          items={pageWatches}
          countLabelPostFix={t('MostPopularPages:countLabelPostFix.watched')}
          emptyNotice={t('MostPopularPages:notice.noWatches')}
        />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.mostFavorited')} id="most-popular-pages-tab-favorited">
        <MostPopularPagesTable
          caption={t('MostPopularPages:caption.favorites')}
          items={pageFavorites}
          countLabelPostFix={t('MostPopularPages:countLabelPostFix.favorites')}
          emptyNotice={t('MostPopularPages:notice.noFavorites')}
        />
      </TabPanel>
    </Tabs>
  );
}

export const PageStatisticsDefaultView = asView(PageStatisticsDefault);
export type PageStatisticsDefaultView = ComponentProps<typeof PageStatisticsDefaultView>;
